import type { ChakraTheme } from "~/foundation/Chakra";

export const space: ChakraTheme["space"] = {
	//base 1 = '4px'
	gridGutter: '2.125rem',
	pageGutter: '2rem',
}